function updateHeader(newBody) {
  if (!newBody) {
    return
  }

  document.body.className = newBody.className

  Object.keys(document.body.dataset).forEach((key) => {
    delete document.body.dataset[key]
  })

  Object.entries(newBody.dataset).forEach(([key, value]) => {
    document.body.dataset[key] = value
  })
}

export default updateHeader